import React, { useState } from 'react';
import {
    TopEventsState,
    TopEventsSportSingleType,
} from 'src/domains/layouts/webview/components/topEvents/TopEventsState.state';
import { observer } from 'src/utils/mobx-react';
import { CompetitionData } from 'src/domains/layouts/webview/components/promotedSports/CompetitionData';
import { Collapse } from 'src/ui/components/collapse/sports/02/Collapse';
import { Collapse as CollapseUnified } from 'src/ui/components/collapse/sports/05/Collapse';
import { TopEventsSportSectionWrapperState } from 'src/domains/layouts/webview/components/topEvents/TopEventsSportSectionWrapper.state';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { TranslationsStore } from 'src/domains/layouts/state/translationsStore/TranslationsStore';

interface TopEventsSportWrapperPropsType {
    sportSlug: string;
    sportData: TopEventsSportSingleType;
    topEventsState: TopEventsState;
}

export const TopEventsSportSectionWrapper = observer(
    'TopEventsSportSectionWrapper',
    ({ sportSlug, sportData }: TopEventsSportWrapperPropsType) => {
        const common = useCommon();
        const [state] = useState(() => new TopEventsSportSectionWrapperState());
        const { unifiedSportEventsTable } = ConfigComponents.get(common).unifiedComponentConfig;
        const translationsStore = TranslationsStore.get(common);

        const sportName = common.models.getSport(sportSlug)?.name ?? translationsStore.translateSport(sportSlug);
        const competitionsSorted = sportData.competitions_list.sort((a, b) => a.display_order - b.display_order);

        return (
            <>
                {unifiedSportEventsTable ? (
                    <CollapseUnified
                        isOpen={state.isOpenedSport}
                        data-test='promoted-event-group'
                        handleToggle={state.setIsOpened}
                        title={sportName}
                    />
                ) : (
                    <Collapse
                        data-test='topEvents-event-group'
                        handleToggle={state.setIsOpened}
                        isOpen={state.isOpenedSport}
                        title={sportName}
                        sportId={sportName}
                    />
                )}

                {state.isOpenedSport ? (
                    <>
                        {competitionsSorted.map((competition) => (
                            <CompetitionData
                                key={competition.id}
                                sportSlug={sportSlug}
                                competition={competition}
                            />
                        ))}
                    </>
                ) : null}
            </>
        );
    }
);
